var render = function render() {
  var _vm$list$_vm$pageInde, _vm$arr$;
  var _vm = this,
    _c = _vm._self._c;
  return _vm.list.length != 0 ? _c("div", {
    staticStyle: {
      "max-height": "600px",
      height: "600px",
      "overflow-y": "auto"
    }
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t((_vm$list$_vm$pageInde = _vm.list[_vm.pageIndex]) === null || _vm$list$_vm$pageInde === void 0 ? void 0 : _vm$list$_vm$pageInde.controlsGroupPageTypeName)))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-icon", {
    staticClass: "icon",
    style: _vm.pageIndex == 0 ? "color:#eee" : "",
    attrs: {
      type: "left"
    },
    on: {
      click: _vm.previousFun
    }
  }), _vm.arr.length != 0 ? _c("div", {
    staticClass: "phoneBox",
    style: {
      background: `url(${(_vm$arr$ = _vm.arr[0]) === null || _vm$arr$ === void 0 ? void 0 : _vm$arr$.style.backgroundImage}) no-repeat`,
      "background-size": "cover"
    }
  }, [_vm._l(_vm.arr, function (item, index) {
    return _c("mobile-preview", {
      key: index + 1,
      attrs: {
        itemObj: item,
        itemIndex: index,
        arrNum: _vm.arr.length - 1,
        themeColor: _vm.arr[0].style.themeColor,
        isConfigure: false,
        pageType: _vm.list[_vm.pageIndex].controlsGroupPageType,
        pageDescription: _vm.pageDescription,
        pageDescriptionConfig: _vm.pageDescriptionConfig
      },
      on: {
        premiumClick: function ($event) {
          _vm.premiumShow = true;
        }
      }
    });
  }), _vm.pageModalShow ? _c("div", [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      left: "0",
      top: "0",
      "z-index": "1"
    },
    on: {
      click: function ($event) {
        _vm.pageModalShow = false;
      }
    }
  }), _c("page-modal", {
    attrs: {
      pagePopUpConfig: _vm.pagePopUpConfig
    },
    on: {
      popupClick: function ($event) {
        _vm.pageModalShow = false;
      }
    }
  })], 1) : _vm._e()], 2) : _vm._e(), _c("a-icon", {
    staticClass: "icon",
    style: _vm.disableColor ? "color:#eee" : "",
    attrs: {
      type: "right"
    },
    on: {
      click: _vm.nextFun
    }
  })], 1)]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };